import { render, staticRenderFns } from "./runPromotion.vue?vue&type=template&id=ce6ad678&scoped=true"
import script from "./runPromotion.vue?vue&type=script&lang=js"
export * from "./runPromotion.vue?vue&type=script&lang=js"
import style0 from "./runPromotion.vue?vue&type=style&index=0&id=ce6ad678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6ad678",
  null
  
)

export default component.exports